<script>
import TextAccordion from "@js/components/Sections/TextBlocks/TextAccordion.vue";

export default {
    name: "ProductDeliveryInfo",
    components: {TextAccordion}
}
</script>

<template>
    <div class="p-5 border border-gray-200 shadow-sm bg-[#d1ecf1] rounded-lg">
        <div class="text-base font-bold text-black mb-5">
            Доставка
        </div>
        <TextAccordion :minHeight="75">
            <ul class="max-w-md space-y-4 list-disc list-outside text-white text-base md:text-xl ms-6">
                <li class="text-xs text-black font-medium">
                    Компания ООО «Дорожные Плиты» предоставляет услуги по доставке ЖБИ на объекты заказчиков. Мы гарантируем
                    оперативную транспортировку с соблюдением всех требований безопасности и технических норм.
                </li>
                <li class="text-xs text-black font-medium">
                    Мы доставляем дорожные, аэродромные и площадочные плиты различных типоразмеров. В наличии всегда
                    есть популярные модели, что позволяет нам быстро выполнять заказы без задержек.
                </li>
                <li class="text-xs text-black font-medium">
                    Собственный автопарк включает самогрузы, длинномеры и широкомеры, что позволяет перевозить плиты
                    любой конфигурации и веса. В нашем распоряжении импортные грузовые автомобили SCANIA и MAN с
                    грузоподъемностью от 5 до 40 тонн, что обеспечивает надежность и эффективность логистики.
                </li>
                <li class="text-xs text-black font-medium">
                    Доставка осуществляется по Москве и Московской области. В зависимости от объема заказа и удаленности
                    объекта возможен гибкий график поставок. Мы работаем без посредников, что исключает дополнительные
                    затраты и задержки.
                </li>
            </ul>
        </TextAccordion>
    </div>
</template>

<style scoped lang="scss">

</style>
